module.exports = __webpack_public_path__ + "img/activity.c54a2107.svg";